import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { API_DOCS_PAGE_PATH } from "../api-docs-paths.ts";

export const AppFooter = (): ReactNode => (
  <footer className="app-footer">
    <Link to={API_DOCS_PAGE_PATH} className="app-footer__link">
      API documentation
    </Link>
  </footer>
);
